import { useContext, useEffect, useState } from "react";
import PieChart from "./PieChart";
import BarChartNivo from "./BarChartJS";
import { getBarChart, getPieChart } from "../../service/AnalyticsService";
import {
  BAR_CHART_COLORS,
  BAR_CHART_COLORS_ALLMODALITIES,
  PIE_CHART_COLORS,
} from "../../constants/Constants";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import AnalyticsFilter from "./AnalyticsFilter";
import { t } from "i18next";
import { useQuery, useQueryClient } from "react-query";

import Moment from "moment";
import loaderContext from "../../context/loader/LoaderContext";
import userContext from "../../context/users/UserContext";

const ChartComponent = (props) => {
  const queryClient = useQueryClient();
  const [data, setData] = useState([]);
  const [keys, setKeys] = useState([]);
  const [indexBy, setIndexBy] = useState("");
  const [yAxisText, setYAxisText] = useState("");
  const [showFilterOptions, setShowFilterOptions] = useState(true);
  const [heightForContainer, setHeightForContainer] = useState((props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "70%" : "90%");

  const [modalityIds, setModalityIds] = useState(()=>props.chartType=="edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" ? props.allModalitySelected : []);
  const [clientIds, setClientIds] = useState([]);
  const [pathologyIds, setPathologyIds] = useState(() => props.chartType !== "pathology_count" ? [] : [
    "Tuberculosis",
    "Cardiomegaly",
    "Pleural Effusion",
    "COVID Suspect",
  ]);

  const [providerIds, setProviderIds] = useState([]);
  const [userIds, setUserIds] = useState(()=>props.chartType=="edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" ? props.allRadiologistSelected : []);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { roles } = useContext(userContext);
  const [selectedDate , setSelectedDate] = useState(2);
  const [dateByInComponent, setDateByInComponent] = useState(1);
  const [totalCountForStudies, setTotalCountForStudies] = useState(0);
  const [returnedReasonIds, setReturnedReasonIds] = useState(()=> props.chartType == "returned_studies_count" ? props.allReturnedReasonSelected : []);
  const [raiseAlertReasonIds, setRaiseAlertReasonIds] = useState(()=> props.chartType == "raised_alert_count" ? props.allRaiseAlertReasonSelected : []);

  const today = new Date();
  const toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-1);

  const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const last2DaysDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-1);
  const last3DaysDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-2);
  const lastWeekDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-6);
  const lastMonthDate = new Date(today.getFullYear(), today.getMonth()-1, today.getDate());

  const [filterObjInChartComponent, setFilterObjInChartComponent] = useState({
    dateTo: todayDate,
    dateFrom: last2DaysDate,
  });

  const formatDate = (date) => {
    var currentDate = Moment(date).local().format("DD-MMM-YYYY");
    return date == "" ? "" : currentDate;
  };
  var payload = {
    chartConfigDto: {
      chartType: props.chartType,
      filter: props.dateBy == 1 ? "upload_date" : "study_date",
      dateFrom: formatDate(props.filterObj["dateFrom"]),
      dateTo: formatDate(props.filterObj["dateTo"]),
      selfTat: 0,
    },
  };
  
  var payloadWithOutGlobalFilter = {
    chartConfigDto: {
      chartType: props.chartType,
      filter: dateByInComponent == 1 ? "upload_date" : "study_date",
      dateFrom: formatDate(filterObjInChartComponent["dateFrom"]),
      dateTo: formatDate(filterObjInChartComponent["dateTo"]),
      // filter: props.objForEditedStudies != null ? props.objForEditedStudies["filter"] : "",
      // dateFrom: props.objForEditedStudies != null ? props.objForEditedStudies["dateFrom"] : "",
      // dateTo: props.objForEditedStudies != null ? props.objForEditedStudies["dateTo"] : "",
      // dateFrom: formatDate(last2DaysDate),
      // dateTo: formatDate(todayDate),
      selfTat: 0,
    },
  };

  const handleResetChart = () =>{
    setClientIds([]);
    setModalityIds(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" ? props.allModalitySelected : []);
    setProviderIds([]);
    setUserIds(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" ? props.allRadiologistSelected : []);
    setSelectedDate(2);
    setDateByInComponent(1);
    setReturnedReasonIds(props.chartType == "returned_studies_count" ? props.allReturnedReasonSelected : []);
    setRaiseAlertReasonIds(props.chartType == "raised_alert_count" ? props.allRaiseAlertReasonSelected : []);
    setTimeout(() => {
      dataQuery.refetch();
    },100)
  }

  useEffect(()=>{
    let date = new Date();
    let toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    console.log("today Date: ", toDate);
    if(props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count"){
      if(selectedDate == 1){
        date = todayDate;
      }else if(selectedDate == 2){
        date = last2DaysDate;
      }else if(selectedDate == 3){
        date = last3DaysDate;
      }else if(selectedDate == 4){
        date = lastWeekDate;
      }else if(selectedDate == 5){
        date = lastMonthDate;
      }else{
        date = payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom != undefined ? new Date(payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom) : date;
        toDate = payloadWithOutGlobalFilter?.chartConfigDto?.dateTo != undefined ? new Date(payloadWithOutGlobalFilter?.chartConfigDto?.dateTo) : todayDate;
      }
      console.log("date , toDate---", date, toDate);
      setFilterObjInChartComponent({ ...filterObjInChartComponent, dateFrom: date, dateTo: toDate });
    }
  },[selectedDate]);

  const fetchTAT = (payload) => {
    return fetchBarChart(payload);
  };

  const fetchStudyOnPlatform = (payload) => {
    return fetchBarChart(payload);
  };

  const fetchGenderWiseDistribution = (payload) => {
    return fetchBarChart(payload);
  };

  const fetchReportingStatus = (payload) => {
    return fetchBarChart(payload);
  };

  const fetchEditedReportsOnPlatform = (payloadWithOutGlobalFilter) => {
    return fetchBarChart(payloadWithOutGlobalFilter);
  }

  const fetchReturnedStudiesOnPlatform = (payloadWithOutGlobalFilter) => {
    return fetchBarChart(payloadWithOutGlobalFilter);
  }

  const fetchRaiseAlertStudiesOnPlatform = (payloadWithOutGlobalFilter) => {
    return fetchBarChart(payloadWithOutGlobalFilter);
  }

  const fetchAllRadCountsForEditiedOrReturnedOrRaisedCharts = (entries) => {
    let temp = [];
    let count = 0;
    temp = entries.map((e)=>{
      let name = e[0];
      count += e[1][0][name];
    })
    setTotalCountForStudies(count);
    return count;
  }

  const fetchBarChart = async (payload) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    let finalPayload = props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count" ? payloadWithOutGlobalFilter : payload;
    console.log("payload:::...",finalPayload);
    let response = await getBarChart(finalPayload);
    let totalCount = 0;
    if (response.status === 200) {
      let objectEntries = Object.entries(response.data.data.chartData);
      console.log("Object entries----", objectEntries);

      if (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") {
        totalCount = fetchAllRadCountsForEditiedOrReturnedOrRaisedCharts(objectEntries);
      }
      
      let objectEntriesLengthUp = objectEntries.length * 30;
      let height = (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? objectEntries.length > 15 ? objectEntriesLengthUp+"px" : '70%' : '90%';
      setHeightForContainer(height);
      // props.objForEditedStudies != null && props.setObjForEditedStudies({
      //   dateFrom: formatDate(filterObjInChartComponent["dateFrom"]),
      //   dateTo: formatDate(filterObjInChartComponent["dateTo"]),
      //   selectedDate: selectedDate,
      //   dateByInComponent: dateByInComponent,
      //   totalCounts: props.totalCountForStudies
      // });



      let tempList = [];
      let tempKeys = [];
      let indexByTemp = "";
      let yaxis = "";
      if (props.chartType == "report_count") {
        indexByTemp = "Hospitals";
        yaxis = "No. of studies";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      } else if (props.chartType == "upload_count") {
        indexByTemp = "Hospitals";
        yaxis = "No. of studies";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      } else if (props.chartType == "gender_count") {
        indexByTemp = "Pathology";
        yaxis = "No. of studies";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      } else if (props.chartType == "user_count") {
        indexByTemp = "Providers";
        yaxis = "Turn Around Time in Minutes";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      } else if (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") {
        indexByTemp = "No of studies";
        yaxis = "Radiologists";
        setIndexBy(indexByTemp);
        setYAxisText(yaxis);
      }
      for (let [key, value] of objectEntries) {
        let obj = {};
        obj[indexByTemp] = key;
        value.forEach((v, index) => {
          obj[Object.keys(v)[0]] = Object.values(v)[0];
          obj[`${Object.keys(v)[0]}Color`] = BAR_CHART_COLORS[index];
          if (!tempKeys.includes(Object.keys(v)[0])) {
            tempKeys.push(Object.keys(v)[0]);
          }
        });
        obj["AllModalitiesColor"] = BAR_CHART_COLORS_ALLMODALITIES;
        tempList.push(obj);
      }
      setData(tempList);
      setKeys(tempKeys);
      setLoaderRunning(false);
      ref.current.complete();
      console.log("totalCountForStudies, count----------------",totalCountForStudies, totalCount);
      return {
        payload,
        payloadWithOutGlobalFilter,
        chartType: props.chartType,
        chartData: tempList,
        chartKeys: tempKeys,
        indexby: indexByTemp,
        yAxisText: yaxis,
        selectedDate: selectedDate,
        totalCountForStudies: totalCount,
        heightForContainer: height
      };
    } else {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const fetchPieChart = async (payload) => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await getPieChart(payload);
    if (response.status === 200) {
      let responseList = response.data.data.chartData;
      responseList.forEach((element, index) => {
        element.color = PIE_CHART_COLORS[index];
      });
      setData(responseList);
      setLoaderRunning(false);
      ref.current.complete();
      return {
        payload,
        chartType: props.chartType,
        chartData: responseList,
        chartKeys: undefined,
      };
    } else {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const fetchData = async () => {
    if (props.isBar) {
      if (props.chartType == "upload_count") {
        if (modalityIds.length > 0) {
          payload["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (clientIds.length > 0) {
          payload["chartConfigDto"]["hospitalIds"] = clientIds;
        }
        return fetchStudyOnPlatform(payload);
      } else if (props.chartType == "gender_count") {
        if (pathologyIds.length > 0) {
          payload["chartConfigDto"]["annotationIds"] = pathologyIds;
        }
        return fetchGenderWiseDistribution(payload);
      } else if (props.chartType == "report_count") {
        if (clientIds.length > 0) {
          payload["chartConfigDto"]["hospitalIds"] = clientIds;
        }
        return fetchReportingStatus(payload);// || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count"
      } else if (props.chartType == "edit_reports_count") {
        if (modalityIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (userIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["userIds"] = userIds;
        }else{
          props.setAlertSuccessModal(() => {
            const newItem = { ...props.alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.description = t("analytics.min-radiologist-selected");
            return newItem;
          });
      }
        return fetchEditedReportsOnPlatform(payloadWithOutGlobalFilter);
      }else if (props.chartType == "returned_studies_count") {
        if (modalityIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (userIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["userIds"] = userIds;
        }else{
            props.setAlertSuccessModal(() => {
              const newItem = { ...props.alertSuccessModal };
              newItem.show = true;
              newItem.heading = "Error";
              newItem.description = t("analytics.min-radiologist-selected");
              return newItem;
            });
        }
        if(returnedReasonIds.length > 0){
          payloadWithOutGlobalFilter["chartConfigDto"]["returnedReasons"] = returnedReasonIds;
        }else{
          payloadWithOutGlobalFilter["chartConfigDto"]["returnedReasons"] = [];
        }
        return fetchReturnedStudiesOnPlatform(payloadWithOutGlobalFilter);
      }else if (props.chartType == "raised_alert_count") {
        if (modalityIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (userIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["userIds"] = userIds;
        }else{
          props.setAlertSuccessModal(() => {
            const newItem = { ...props.alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Error";
            newItem.description = t("analytics.min-radiologist-selected");
            return newItem;
          });
      }
        if (raiseAlertReasonIds.length > 0) {
          payloadWithOutGlobalFilter["chartConfigDto"]["raiseAlerts"] = raiseAlertReasonIds;
        }else{
          payloadWithOutGlobalFilter["chartConfigDto"]["raiseAlerts"] = [];
        }
        return fetchRaiseAlertStudiesOnPlatform(payloadWithOutGlobalFilter);
      } else {
        if (modalityIds.length > 0) {
          payload["chartConfigDto"]["modalityIds"] = modalityIds;
        }
        if (clientIds.length > 0) {
          payload["chartConfigDto"]["hospitalIds"] = clientIds;
        }
        if (providerIds.length > 0) {
          payload["chartConfigDto"]["userIds"] = providerIds;
        }
        return fetchTAT(payload);
      }
    } else if (props.isPie) {
      if (pathologyIds.length > 0) {
        payload["chartConfigDto"]["annotationIds"] = pathologyIds;
      }
      return fetchPieChart(payload);
    }
  };

  const dataQuery = useQuery(
    [props.chartType, props.filterObj, props.dateBy],
    () => fetchData(),
    {
      keepPreviousData: true,
      staleTime: Infinity, // Set stale time to 5 minutes
      cacheTime: 15 * 60 * 1000, // Set cache time to 5 minutes
      initialData: () => {
        return queryClient.getQueryData(["data"]);
      },
      initialDataUpdatedAt: () =>
        queryClient.getQueryState(["data"])?.dataUpdatedAt,
    }
  );
  useEffect(() => {
    props?.setIsOnlineRadiologistSelected(false);

  }, [])
  
  useEffect(() => {
    if (dataQuery.data) {
      if(props.chartType=="edit_reports_count" || props.chartType=="returned_studies_count" || props.chartType=="raised_alert_count"){
        if (props.isBar) {
          setYAxisText(dataQuery.data.yAxisText);
          setIndexBy(dataQuery.data.indexby);
          setData(dataQuery.data.chartData);
          setKeys(dataQuery.data.chartKeys);
        } else {
          setData(dataQuery.data.chartData);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.userIds != undefined) {
          setProviderIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.userIds);
        } else {
          setProviderIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.modalityIds != undefined) {
          setModalityIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.modalityIds);
        } else {
          setModalityIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.hospitalIds != undefined) {
          setClientIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.hospitalIds);
        } else {
          setClientIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.annotationIds != undefined) {
          setPathologyIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.annotationIds);
        } else {
          setPathologyIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.userIds != undefined) {
          setUserIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.userIds);
        }else{
          setUserIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.returnedReasons != undefined) {
          setReturnedReasonIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.returnedReasons);
        }else{
          setReturnedReasonIds([]);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.raiseAlerts != undefined) {
          setRaiseAlertReasonIds(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.raiseAlerts);
        }else{
          setRaiseAlertReasonIds([]);
        }
        if (dataQuery.data?.selectedDate != undefined) {
          setSelectedDate(dataQuery.data?.selectedDate);
        }else{
          setSelectedDate(2);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.filter != undefined) {
          setDateByInComponent(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.filter == "upload_date" ? 1 : 2);
        }else{
          setDateByInComponent(1);
        }
        if (dataQuery.data?.totalCountForStudies != undefined || dataQuery.data?.totalCountForStudies != null) {
          console.log("total count in if ---",dataQuery.data?.totalCountForStudies);
          setTotalCountForStudies(dataQuery.data?.totalCountForStudies);
        }else{
          setTotalCountForStudies(0);
        }
        if (dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom != undefined || dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom != null) {
          let dateFrom = new Date(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.dateFrom);
          let dateTo = new Date(dataQuery.data?.payloadWithOutGlobalFilter?.chartConfigDto?.dateTo);
          console.log("date from-----------",dateFrom);
          console.log("date to-----------",dateTo);
          let tempFilterObj = {
            dateFrom: dateFrom,
            dateTo: dateTo
          }
          setFilterObjInChartComponent(tempFilterObj);
        }else{
          let tempFilterObj = {
            dateFrom: last2DaysDate,
            dateTo: todayDate
          }
          setFilterObjInChartComponent(tempFilterObj);
        }
        console.log("filterObjInChartComponent----------------------",filterObjInChartComponent);
        if(dataQuery.data?.heightForContainer != undefined && dataQuery.data?.heightForContainer != null){
          setHeightForContainer(dataQuery.data?.heightForContainer);
        }else{
          setHeightForContainer("90%");
        }
      }else{
        if (props.isBar) {
          setYAxisText(dataQuery.data.yAxisText);
          setIndexBy(dataQuery.data.indexby);
          setData(dataQuery.data.chartData);
          setKeys(dataQuery.data.chartKeys);
        } else {
          setData(dataQuery.data.chartData);
        }
        if (dataQuery.data?.payload?.chartConfigDto?.userIds != undefined) {
          setProviderIds(dataQuery.data?.payload?.chartConfigDto?.userIds);
        } else {
          setProviderIds([]);
        }
        if (dataQuery.data?.payload?.chartConfigDto?.modalityIds != undefined) {
          setModalityIds(dataQuery.data?.payload?.chartConfigDto?.modalityIds);
        } else {
          setModalityIds([]);
        }
        if (dataQuery.data?.payload?.chartConfigDto?.hospitalIds != undefined) {
          setClientIds(dataQuery.data?.payload?.chartConfigDto?.hospitalIds);
        } else {
          setClientIds([]);
        }
        if (dataQuery.data?.payload?.chartConfigDto?.annotationIds != undefined) {
          setPathologyIds(dataQuery.data?.payload?.chartConfigDto?.annotationIds);
        } else {
          setPathologyIds([]);
        }
    }
  }}, [props.dateBy]);


  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
          paddingTop: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "" : "10px",
          position: "relative",
          // alignItems: "center",
          alignItems:"flex-end",
          borderBottom: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "1px solid rgb(88, 88, 88)" : ""
        }}
      >
        {/* <PrimaryButton
          iconProps={addIcon}
          onClick={() => {
            setShowFilterOptions((prev) => !prev);
          }}
          text={t("analytics.add-filter")}
          style={
            showFilterOptions
              ? addFilterActive
              : {
                  fontSize: "12px",
                  fontWeight: "400",
                  padding: "0px 3px",
                  whiteSpace: "nowrap",
                }
          }
        /> */}
        <AnalyticsFilter
          show={showFilterOptions}
          modalityList={props.modalityList}
          clientList={props.clientList}
          annotationList={props.pathologyList}
          providerList={props.providerList}
          userList={props.userList}
          modalityIds={modalityIds}
          clientIds={clientIds}
          pathologyIds={pathologyIds}
          providerIds={providerIds}
          userIds={userIds}
          setClientIds={setClientIds}
          setModalityIds={setModalityIds}
          setPathologyIds={setPathologyIds}
          setProviderIds={setProviderIds}
          setUserIds={setUserIds}
          role={roles[0]}
          setAlertSuccessModal={props.setAlertSuccessModal}
          alertSuccessModal={props.alertSuccessModal}
          chartType={props.chartType}
          dateList={props.dateList}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          dateByInComponent={dateByInComponent}
          setDateByInComponent={setDateByInComponent}
          filterObjInChartComponent={filterObjInChartComponent}
          setFilterObjInChartComponent={setFilterObjInChartComponent}
          allModalitySelected={props.allModalitySelected}
          allRadiologistSelected={props.allRadiologistSelected}
          returnedReasonList={props.returnedReasonList}
          returnedReasonIds={returnedReasonIds}
          setReturnedReasonIds={setReturnedReasonIds}
          raiseAlertReasonList={props.raiseAlertReasonList}
          raiseAlertReasonIds={raiseAlertReasonIds}
          setRaiseAlertReasonIds={setRaiseAlertReasonIds}
        />
        <div style={{display:"flex",flexDirection:"row", margin:"5px", paddingBottom:"10px", paddingLeft:"10px"}}>
        <PrimaryButton
          onClick={() => {
            dataQuery.refetch();
          }}
          text={t("analytics.apply")}
          style={{
            fontSize: "12px",
            fontWeight: "400",
            padding: "0px 3px",
            whiteSpace: "nowrap",
            marginLeft: "5px",
          }}
        />

        {(props.chartType != "edit_reports_count" && props.chartType != "returned_studies_count" && props.chartType != "raised_alert_count") ? <DefaultButton
          onClick={() => {
            setClientIds([]);
            setPathologyIds([]);
            setModalityIds([]);
            setProviderIds([]);
            setTimeout(() => {
              dataQuery.refetch();
            }, 100);
          }}
          text={t("analytics.clear")}
          style={{
            fontSize: "12px",
            fontWeight: "400",
            padding: "0px 3px",
            whiteSpace: "nowrap",
            marginLeft: "5px",
          }}
        />
        :
        <DefaultButton
          onClick={() => {
            handleResetChart();
          }}
          text={t("analytics.reset")}
          style={{
            fontSize: "12px",
            fontWeight: "400",
            padding: "0px 3px",
            whiteSpace: "nowrap",
            marginLeft: "5px",
          }}
        />
        }
        </div>
      </div>
      {props.chartType == "edit_reports_count" && <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
        <div className="form-mt-10" style={{width:"95%"}}>Total Count of Edited Reports by Radiologist: {totalCountForStudies}</div>
      </div>
      }
      {props.chartType == "returned_studies_count" && <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
        <div className="form-mt-10" style={{width:"95%"}}>Total Count of Returned Studies by Radiologist: {totalCountForStudies}</div>
      </div>
      }
      {props.chartType == "raised_alert_count" && <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
        <div className="form-mt-10" style={{width:"95%"}}>Total Count of Raise Alert Studies by Radiologist: {totalCountForStudies}</div>
      </div>
      }
      <div
        style={{
          height: heightForContainer,
          minHeight: (props.chartType == "edit_reports_count" || props.chartType == "returned_studies_count" || props.chartType == "raised_alert_count") ? "73%" : "90%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            height: "95%",
            width: "95%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {props.isBar && data.length > 0 && (
            <BarChartNivo
              data={data}
              keys={keys}
              chartType={props.chartType}
              indexBy={indexBy}
              yAxisText={yAxisText}
              totalCountForStudies={totalCountForStudies}
            />
          )}
          {props.isPie && data.length > 0 && <PieChart data={data} />}
          {data.length <= 0 && props.isPie && (
            <div>
              No data to display. Please select findings to display the
              "Study Distribution based on findings" pie chart.
            </div>
          )}
          {data.length <= 0 && props.isBar && (
            <div>
              No data to display. Please add filters to display the chart.
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChartComponent;
